export interface BlogPost {
  title: string;
  subtitle: string;
  date: string;
  author: string;
  slug: string;
  description: string;
  keywords: string;
  published: boolean;
  content: string;
  readingTime: number;
}

function parseFrontmatter(raw: string): { meta: Record<string, string>; content: string } {
  const match = raw.match(/^---\n([\s\S]*?)\n---\n([\s\S]*)$/);
  if (!match) return { meta: {}, content: raw };
  const meta: Record<string, string> = {};
  for (const line of match[1].split('\n')) {
    const idx = line.indexOf(':');
    if (idx === -1) continue;
    const key = line.slice(0, idx).trim();
    let val = line.slice(idx + 1).trim();
    if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
      val = val.slice(1, -1);
    }
    meta[key] = val;
  }
  return { meta, content: match[2].trim() };
}

function estimateReadingTime(text: string): number {
  const words = text.split(/\s+/).length;
  return Math.max(1, Math.round(words / 230));
}

const modules = import.meta.glob('/src/content/blog/*.md', { query: '?raw', import: 'default', eager: true });

function loadAllPosts(): BlogPost[] {
  const posts: BlogPost[] = [];
  for (const [, raw] of Object.entries(modules)) {
    const { meta, content } = parseFrontmatter(raw as string);
    if (meta.published === 'false') continue;
    posts.push({
      title: meta.title || '',
      subtitle: meta.subtitle || '',
      date: meta.date || '',
      author: meta.author || 'A practicing radiologist',
      slug: meta.slug || '',
      description: meta.description || '',
      keywords: meta.keywords || '',
      published: meta.published !== 'false',
      content,
      readingTime: estimateReadingTime(content),
    });
  }
  return posts.sort((a, b) => (b.date > a.date ? 1 : -1));
}

let _cache: BlogPost[] | null = null;
export function getAllPosts(): BlogPost[] {
  if (!_cache) _cache = loadAllPosts();
  return _cache;
}

export function getPostBySlug(slug: string): BlogPost | undefined {
  return getAllPosts().find((p) => p.slug === slug);
}
